import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Paper, Grid, Typography } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import { RadialBarChart, RadialBar, ResponsiveContainer, PolarAngleAxis } from 'recharts';
import Box from '@material-ui/core/Box';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'

import 'react-day-picker/lib/style.css'
import { styles } from '../../classes/Styles'
import { VIEWERSHIP_OVERLAP } from '../../constants/module_info'

class HomeViewershipOverlapComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    homepage: PropTypes.string,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    screenWidth: PropTypes.number
  }

  constructor (props) {
    super(props)

    this.state = {
      toggleViewership: false
    }
  }

  handleViewership =()=> {
    const currentStatus=this.state.toggleViewership;
    this.setState({
      toggleViewership: !currentStatus
    })
  }

  render () {
    const { classes, homepage, metrics } = this.props
    const toggleViewership = this.state.toggleViewership

    return (
      <Paper className={`d-flex flex-column justify-content-between  ${classes.paper}`}>
        <Grid container spacing={1} direction="column">
          <Grid item>
            <Box>
              <span className={classes.cardTitle}>Viewership Overlap</span>
              <OverlayTrigger overlay={<Tooltip id="tooltip">{VIEWERSHIP_OVERLAP}</Tooltip>} placement="right">
                <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
              </OverlayTrigger>
            </Box>
          </Grid>
          <Grid item className={classes.cardSubTitle}>How the {homepage} audience engages with content from other networks</Grid>
        </Grid>
        { (metrics && metrics.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (metrics && metrics.details) &&
          <Grid container spacing={2}>
            <Grid item xl={5} lg={5} md={5} sm={6} xs={12} className={classes.viewership}>
              <ViewershipChart classes={classes} metrics={metrics} toggleViewership={toggleViewership} />
            </Grid>
            <Grid item xl={7} lg={7} md={7} sm={6} xs={12} className={classes.viewershipOverlap}>
              <TopOverlappingNetworks classes={classes} metrics={metrics} toggleViewership={toggleViewership} />
            </Grid>
          </Grid>
        }
        { (metrics && metrics.details) &&
        <Box className="d-flex align-items-center justify-content-end">
          <Box>
            <Typography className="pagingInfoText">{!toggleViewership ? '1-5' : '6-10'} of 10</Typography>
          </Box>
          <Box className="pagingArrow">
            <KeyboardArrowLeftIcon fontSize="small" onClick={this.handleViewership} className={`${classes.pointer} ${!toggleViewership && classes.eventDisable}`}/>
            <KeyboardArrowRightIcon fontSize="small" onClick={this.handleViewership} className={`${classes.pointer} ${toggleViewership && classes.eventDisable}`}/>
          </Box>
        </Box>
      }
      </Paper>
    )
  }
}

class ViewershipChart extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    toggleViewership: PropTypes.bool.isRequired
  }

  render () {
    const { metrics } = this.props
    const chartData = metrics.details && metrics.details.viewership_overlap.top5_viewership_overlap
    const dataToggle = this.props.toggleViewership
    const data = [
      {
        name: chartData[4].col, uv: chartData[4].score, fill: '#DA22BC'
      },
      {
        name: chartData[3].col, uv: chartData[3].score, fill: '#DA2222'
      },
      {
        name: chartData[2].col, uv: chartData[2].score, fill: '#E5750C'
      },
      {
        name: chartData[1].col, uv: chartData[1].score, fill: '#228DDA'
      },
      {
        name: chartData[0].col, uv: chartData[0].score, fill: '#22DA4B'
      }
    ]
    const data1 = [
      {
        name: chartData[9].col, uv: chartData[9].score, fill: '#DA22BC'
      },
      {
        name: chartData[8].col, uv: chartData[8].score, fill: '#DA2222'
      },
      {
        name: chartData[7].col, uv: chartData[7].score, fill: '#E5750C'
      },
      {
        name: chartData[6].col, uv: chartData[6].score, fill: '#228DDA'
      },
      {
        name: chartData[5].col, uv: chartData[5].score, fill: '#22DA4B'
      }
    ]

    return (
      <div className='viewershipRadialBar viewershipBorderRight' style={{ width: '100%', height: 150 }}>
        <ResponsiveContainer>
          <RadialBarChart width={250} height={150} cx={70} cy={70} innerRadius={'30%'} outerRadius={'110%'} barSize={20} data={!dataToggle ? data : data1}
            startAngle={180}
            endAngle={-180}
            minAngle={0}
            maxAngle={180}
          >
            <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
            <RadialBar minAngle={15} label={{ display: 'none', position: 'insideStart', fill: '#fff' }} background clockWise={true} dataKey="uv"/>
          </RadialBarChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

class TopOverlappingNetworks extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    toggleViewership: PropTypes.bool.isRequired
  }

  render () {
    const { classes, metrics } = this.props
    let chartData = metrics.details && metrics.details.viewership_overlap.top5_viewership_overlap
    const dataNew = this.props.toggleViewership
    let sliceData = dataNew ? chartData.slice(5, 8) : chartData.slice(0, 3)
    let sliceData1 = dataNew ? chartData.slice(8, 10) : chartData.slice(3, 5)

    return (
      <Grid item container direction="column" justify="center" spacing={1}>
        <Grid item className={classes.viewershipNetworkTitle}>Top Overlapping Networks</Grid>
        <Grid item className={classes.viewershipNetwork}>
          <ul className={classes.viewershipNetworkList}>
            { sliceData.map((data, index) => {
                return (
                  <li className={classes.viewershipNetworkLists} key={data.col}>
                    <span className={classes.viewershipNetworkListSpan}>
                      <span className={`${classes.viewershipCircle} ${index === 0 ? classes.viewershipCircle1 : index === 1 ? classes.viewershipCircle2 : index === 2 ? classes.viewershipCircle3 : ''}`}></span>
                      <span>{data.col}</span>
                    </span>
                    <span className={classes.viewershipNetworkSpan}>{data.score}%</span>
                  </li>
                )
              })
            }
          </ul>
          <ul className={classes.viewershipNetworkList}>
            { sliceData1.map((data, index) => {
                return (
                  <li className={classes.viewershipNetworkLists} key={data.col}>
                    <span className={classes.viewershipNetworkListSpan}>
                      <span className={`${classes.viewershipCircle} ${index === 0 ? classes.viewershipCircle4 : index === 1 ? classes.viewershipCircle5 : ''}`}></span>
                      <span>{data.col}</span>
                    </span>
                    <span className={classes.viewershipNetworkSpan}>{data.score}%</span>
                  </li>
                )
              })
            }
          </ul>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(HomeViewershipOverlapComponent)